// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-pages-usageReportingContainer-usageReporting-module__container--vn77N {
  padding: 15px;
}

.src-js-pages-usageReportingContainer-usageReporting-module__pageTitle--pnQm2 {
  color: #ffffff;
  background-color: #071c35;
  padding: 10px 0;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/js/pages/usageReportingContainer/usageReporting.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".container {\n  padding: 15px;\n}\n\n.pageTitle {\n  color: #ffffff;\n  background-color: #071c35;\n  padding: 10px 0;\n  text-transform: uppercase;\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `src-js-pages-usageReportingContainer-usageReporting-module__container--vn77N`,
	"pageTitle": `src-js-pages-usageReportingContainer-usageReporting-module__pageTitle--pnQm2`
};
export default ___CSS_LOADER_EXPORT___;
